import React from 'react'
import styled from '@emotion/styled'
import RightArrow from 'src/components/atoms/RightArrow'
import { BreakPoint } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

class AccordionMenu extends React.Component {
  constructor() {
    super()
    this.state = {
      isOpen: false
    }
  }

  toggle = () => {
    this.setState(() => {
      return { isOpen: !this.state.isOpen }
    })
  }

  // 文字列をJSXにして返す関数
  parseAnswerHTML = answer => {
    return (
      <div
        className="Container"
        dangerouslySetInnerHTML={{ __html: answer }}
      ></div>
    )
  }

  render() {
    return (
      <Container>
        <Wrapper onClick={this.toggle}>
          <Question as="p">{this.props.question}</Question>
          <RightArrowWrapper isOpen={this.state.isOpen}>
            <RightArrow />
          </RightArrowWrapper>
        </Wrapper>
        <Answer isOpen={this.state.isOpen}>
          {this.parseAnswerHTML(this.props.answer)}
        </Answer>
      </Container>
    )
  }
}

const Container = styled.div`
  width: 100%;
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`

const Question = styled(Typography)`
  margin-left: 50px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: 1.12px;
  text-align: left;
  color: #333333;
  position: relative;
  &:before {
    content: 'Q';
    position: absolute;
    left: -50px;
    top: -1px;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 30px;
    letter-spacing: 1.2px;
    color: #fafafa;
    background-color: #22475d;
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
`

const Answer = styled.div`
  font-family: HiraKakuPro-W3;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: 1.12px;
  text-align: left;
  color: #333333;
  margin-left: 50px;
  margin-top: ${({ isOpen }) => (isOpen ? '26px' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  height: ${({ isOpen }) => (isOpen ? '108px' : '0px')};
  transition: 0.5s;
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    height: ${({ isOpen }) => (isOpen ? '158px' : '0px')};
  }
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    height: ${({ isOpen }) => (isOpen ? '258px' : '0px')};
  }
`

const RightArrowWrapper = styled.div`
  fill: #22475d;
  width: 24px;
  height: 24px;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg);' : 'rotate(90deg);')};
  transition: 0.5s;
`

export default AccordionMenu
